export default {
  NotTaxObject: '01',
  EnableTaxObject: '02',
  EnableTaxObjectWithoutBreakDown: '03',
};
